/* THE IN-APP BROWSER LINE (website room, 2026-09-27). Runs only where snippets/hb-inapp.liquid rendered its block.
   1. Names the browser from the user agent: Instagram, Facebook, TikTok, Snapchat, Pinterest or LinkedIn by their own
      markers; any other app's web view by the generic signs (Android "; wv)", or an iPhone WebKit with no Safari token).
      Safari, Chrome, the YouTube app (Safari View Controller on iPhone, a Chrome tab on Android) and the Google app
      carry none of those signs, so the line never shows there.
   2. Builds the hand-off link from /cart.js: a Shopify cart permalink /cart/VARIANT:QTY,... with utm_source=<app>,
      utm_medium=inapp_handoff, utm_campaign=cart_handoff (the app keeps its credit; the hand-off is read by the medium),
      the cart test side and the app as order attributes (__cart_test from window.__cartv, __inapp), the applied discount
      code when there is one, and a personalized line's visible properties (Base64-URL JSON, first product only; with two
      personalized lines there is no link, so a name is never dropped). The same cart opens in the real browser.
   3. On the tap: copies the https link (inside the tap, so the clipboard allows it), then jumps out - iPhone through
      x-safari-https:// (iOS 17 and later), Android through a Chrome intent with the https link as its fallback. If this
      screen is still showing 1.6 s later the jump was blocked, and the fallback line (the ... menu, Open in browser) shows.
   4. Counts: the tap goes to window.traxEmit('select_promotion', promotion_id 'inapp_handoff') as the hubs count theirs;
      the line's showing is published as a Shopify analytics event 'trax:inapp_line' for the pixel to pick up if listed.
   Test hook: window.__hbInappNav = function(url){} receives the jump URL instead of navigating (the headless proof). */
(function () {
  if (window.__hbInapp) return; window.__hbInapp = true;
  var d = document, ua = navigator.userAgent || '';
  var ios = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var android = /Android/i.test(ua);
  var app = /Instagram/i.test(ua) ? 'Instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBAN\//i.test(ua) ? 'Facebook'
    : /musical_ly|BytedanceWebview|Bytedance|TikTok/i.test(ua) ? 'TikTok' : /Snapchat/i.test(ua) ? 'Snapchat'
    : /Pinterest/i.test(ua) ? 'Pinterest' : /LinkedInApp/i.test(ua) ? 'LinkedIn' : /Twitter|TwitterAndroid/i.test(ua) ? 'X' : '';
  var webview = ios ? (/AppleWebKit/i.test(ua) && !/Safari\//i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\//i.test(ua))
    : android ? /;\s?wv\)/i.test(ua) : false;
  if (!app && !webview) return;
  var blocks = [].slice.call(d.querySelectorAll('[data-hb-inapp]'));
  if (!blocks.length) return;
  var browser = ios ? 'Safari' : android ? 'Chrome' : 'your browser';
  var pay = ios ? 'Apple Pay' : android ? 'Google Pay' : 'your usual ways to pay';
  var appName = app || 'this app';
  var campaign = (app || 'app').toLowerCase();
  var cartUrl = (blocks[0].getAttribute('data-cart-url') || '/cart').replace(/\/$/, '');
  var httpsLink = '';
  function fill() {
    blocks.forEach(function (b) {
      [].forEach.call(b.querySelectorAll('[data-inapp-app]'), function (e) { e.textContent = appName; });
      [].forEach.call(b.querySelectorAll('[data-inapp-browser]'), function (e) { e.textContent = browser; });
      [].forEach.call(b.querySelectorAll('[data-inapp-pay]'), function (e) { e.textContent = pay; });
      var t = b.querySelector('.hb-inapp-t');
      if (t && !app) t.firstChild.nodeValue = 'You are shopping inside ';
    });
  }
  function visibleProps(item) {
    var p = item && item.properties, out = {}, n = 0;
    if (!p || typeof p !== 'object') return null;
    for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k) && k.charAt(0) !== '_' && p[k] !== null && p[k] !== undefined && p[k] !== '') { out[k] = String(p[k]); n++; } }
    return n ? out : null;
  }
  function b64url(s) { try { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); } catch (e) { return ''; } }
  function build(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return '';
    // personalized lines (a name, a letter, a photo): the permalink carries properties (Base64-URL JSON, up to 25) for the
    // FIRST product only, so one such line goes first; with two or more the hand-off would drop a name, so there is no link
    var withProps = [], plain = [];
    items.forEach(function (i) { var vp = visibleProps(i); if (vp) withProps.push({ i: i, p: vp }); else plain.push(i); });
    if (withProps.length > 1) return '';
    var props = '';
    if (withProps.length === 1) { if (Object.keys(withProps[0].p).length > 25) return ''; props = b64url(JSON.stringify(withProps[0].p)); if (!props) return ''; }
    var ordered = withProps.map(function (w) { return w.i; }).concat(plain);
    var parts = ordered.map(function (i) { return i.variant_id + ':' + (i.quantity || 1); });
    // the app keeps its credit (utm_source), the hand-off is read by utm_medium; the cart test side and the app ride as order attributes
    var side = String(window.__cartv || '').toUpperCase() === 'B' ? 'cart_v2_B' : 'cart_v2_A';
    var u = location.origin + cartUrl + '/' + parts.join(',') + '?utm_source=' + encodeURIComponent(campaign) + '&utm_medium=inapp_handoff&utm_campaign=cart_handoff';
    if (props) u += '&properties=' + props;
    u += '&attributes[__cart_test]=' + side + '&attributes[__inapp]=' + encodeURIComponent(campaign);
    var codes = cart.discount_codes || [];
    for (var k = 0; k < codes.length; k++) { if (codes[k] && codes[k].code && codes[k].applicable !== false) { u += '&discount=' + encodeURIComponent(codes[k].code); break; } }
    return u;
  }
  function jumpUrl(https) {
    if (ios) return 'x-safari-' + https;
    if (android) return 'intent://' + https.replace(/^https?:\/\//, '') + '#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=' + encodeURIComponent(https) + ';end';
    return https;
  }
  function copy(text) {
    try { if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).catch(function () {}); return true; } } catch (e) {}
    try { var ta = d.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;left:-9999px;top:0'; d.body.appendChild(ta); ta.select(); var ok = d.execCommand('copy'); d.body.removeChild(ta); return ok; } catch (e2) { return false; }
  }
  function show() {
    fill();
    var shown = 0;
    blocks.forEach(function (b) {
      // the cart fork's side gate: a block inside a .cv2 wrapper that computes display:none (side A) is left hidden and uncounted
      var wrap = b.closest ? b.closest('.cv2') : null;
      if (wrap && getComputedStyle(wrap).display === 'none') { b.hidden = true; return; }
      shown++;
      var go = b.querySelector('[data-inapp-go]'), cp = b.querySelector('[data-inapp-copy]'), fb = b.querySelector('[data-inapp-fallback]'), ok = b.querySelector('[data-inapp-copied]');
      if (go) go.setAttribute('href', httpsLink);
      if (b.__hbWired) { b.hidden = false; return; }
      b.__hbWired = true;
      if (go) {
        go.addEventListener('click', function (e) {
          e.preventDefault();
          var where = b.getAttribute('data-where') || 'page';
          try { if (window.traxEmit) window.traxEmit('select_promotion', { promotion_id: 'inapp_handoff', promotion_name: appName, creative_slot: where + ':' + (ios ? 'ios' : android ? 'android' : 'other'), link_url: httpsLink }); } catch (err) {}
          copy(httpsLink);
          var target = jumpUrl(httpsLink);
          setTimeout(function () { if (d.visibilityState === 'visible' && fb) { fb.hidden = false; } }, 1600);
          if (typeof window.__hbInappNav === 'function') { window.__hbInappNav(target); return; }
          if (ios || android) { location.href = target; } else { window.open(httpsLink, '_blank', 'noopener'); }
        });
      }
      if (cp) cp.addEventListener('click', function () {
        var done = copy(httpsLink);
        if (ok) { ok.textContent = done ? 'Cart link copied.' : httpsLink; ok.hidden = false; }
        try { if (window.traxEmit) window.traxEmit('select_promotion', { promotion_id: 'inapp_copy', promotion_name: appName, creative_slot: b.getAttribute('data-where') || 'page', link_url: httpsLink }); } catch (err) {}
      });
      b.hidden = false;
    });
    if (!shown || published) return;
    published = true;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('trax:inapp_line', { app: appName, os: ios ? 'ios' : android ? 'android' : 'other', path: location.pathname }); } catch (err) {}
  }
  var published = false;
  function apply(cart) {
    httpsLink = build(cart);
    if (httpsLink) show(); else blocks.forEach(function (b) { b.hidden = true; });
  }
  function load() {
    fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(apply).catch(function () {});
  }
  load();
  // the theme's cart manager (assets/cart-utils.js) announces every change as cart:data-updated with the cart in detail;
  // the link follows the cart without a second fetch
  d.addEventListener('cart:data-updated', function (e) { if (e && e.detail && e.detail.cartData) apply(e.detail.cartData); else load(); });
  window.__hbInappReload = load;
})();
